import routes from './routes';
import { SetRoutes } from 'components';

const CandidatesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default CandidatesPages;
